import type { FC, ReactNode } from 'react'
import type { LayoutProps } from '@/types'

import { SiteHeader } from '@/components/generals/site-header'
import { SiteFooter } from '@/components/generals/site-footer'

interface PublicLayoutProps extends LayoutProps {
    // Pages that open with a full-bleed photograph let the header float over it
    overHero?: boolean
}

// Public site shell: fixed header, page content, footer
export const Layout: FC<PublicLayoutProps> = ({ children, overHero = false }): ReactNode => {
    return (
        <div className='flex min-h-screen flex-col'>
            <a
                href='#main-content'
                className='sr-only z-[60] rounded-full bg-forest px-5 py-3 text-sm text-cream focus:not-sr-only focus:fixed focus:left-4 focus:top-4'
            >
                Skip to content
            </a>

            <SiteHeader overHero={overHero} />

            <main id='main-content' className='flex-1'>
                {children}
            </main>

            <SiteFooter />
        </div>
    )
}
